import { RouteLocationRaw, Router } from 'vue-router';
import { ChatGroupId } from '@/chat/models/ChatGroup';
import { WorkshopTeamId } from '@/general/models/WorkshopTeam';
import { formatParamValue } from '@/general/router/util';
import { BrandId } from '../models/Brand';
import { OutletId } from '../models/Outlet';
import { TagId } from '../models/Tag';
import { UserId } from '../models/User';
import { isPresent } from './typescript';

export const OUTLET_QUERY_PARAM = 'outletId';
export const BRAND_QUERY_PARAM = 'brandId';
export const TEAM_QUERY_PARAM = 'teamId';
export const USER_QUERY_PARAM = 'userId';
export const GROUP_QUERY_PARAM = 'groupId';
export const DOSSIER_TAG_QUERY_PARAM = 'dossierTagId';
export const RESTRICTED_USER_PARAM = 'restrictedUserId';

export const USERS_STORAGE_KEY = 'selected_users';
export const GROUPS_STORAGE_KEY = 'selected_groups';
export const DOSSIER_TAGS_STORAGE_KEY = 'selected_dossier_tags';
export const TEAMS_STORAGE_KEY = 'selected_teams';
export const BRANDS_STORAGE_KEY = 'selected_brands';
export const OUTLETS_STORAGE_KEY = 'selected_outlets';
export const RESTRICTED_USER_STORAGE_KEY = 'selected_restricted_user';

export const MAX_CHIPS = 3;

export function getFilterLink(paramName: string, router: Router, value?: any): RouteLocationRaw {
  return {
    query: {
      ...router.currentRoute.value.query,
      [paramName]: formatParamValue(value, paramName),
    },
  };
}

export function saveMultiDossierTagFilter(tagIds: Array<TagId>): void {
  saveMultiFilter(DOSSIER_TAGS_STORAGE_KEY, tagIds);
}

export function saveMultiGroupFilter(groupIds: Array<ChatGroupId>): void {
  saveMultiFilter(GROUPS_STORAGE_KEY, groupIds);
}

export function saveMultiUserFilter(userIds: Array<UserId>): void {
  saveMultiFilter(USERS_STORAGE_KEY, userIds);
}

export function saveSingleTeamFilter(id: WorkshopTeamId | null): void {
  saveSingleFilter(TEAMS_STORAGE_KEY, id);
}

export function saveMultiTeamFilter(teamIds: Array<WorkshopTeamId>): void {
  saveMultiFilter(TEAMS_STORAGE_KEY, teamIds);
}

export function saveSingleBrandFilter(id: BrandId | null): void {
  saveSingleFilter(BRANDS_STORAGE_KEY, id);
}

export function saveMultiBrandFilter(brandIds: Array<BrandId>): void {
  saveMultiFilter(BRANDS_STORAGE_KEY, brandIds);
}

export function saveSingleOutletFilter(id: OutletId | null): void {
  saveSingleFilter(OUTLETS_STORAGE_KEY, id);
}

export function saveMultiOutletFilter(outletIds: Array<OutletId>): void {
  saveMultiFilter(OUTLETS_STORAGE_KEY, outletIds);
}

export function saveSingleFilter<T>(key: string, id: T | null): void {
  isPresent(id) ? sessionStorage.setItem(key, `${id}`) : sessionStorage.removeItem(key);
}

export function saveMultiFilter<T>(key: string, idList: Array<T>): void {
  if (idList.length > 0) {
    sessionStorage.setItem(key, idList.join(','));
  } else {
    sessionStorage.removeItem(key);
  }
}
